/* eslint-disable import/no-extraneous-dependencies */
import { combineReducers } from 'redux';
// import { routerReducer } from "react-router-redux";
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';
import { createBrowserHistory } from 'history';
import oauth from './oauth';
import device from './device';
import permissions from './permissions';
import components from './components';
import common from './common';
import modal from './openModal';
import panel from './panel';
import serviceFlow from './serviceFlow';
import filter from './filter';
import fsm from './fsmManagementSystem';
import otpFlow from './otpFlow';
import callingDetails from './callingDetails';
import exitManagement from './exitManagement';

export const history = createBrowserHistory();

export const createReducer = (asyncReducers = {}) =>
  combineReducers({
    // routing: routerReducer,
    router: connectRouter(history),
    form: formReducer,
    oauth,
    device,
    permissions,
    common,
    modal,
    components,
    panel,
    fsm,
    serviceFlow,
    filter,
    otpFlow,
    callingDetails,
    exitManagement,
    ...asyncReducers,
  });
const asyncReducers = {};

const rootReducer = (state: any, action: any) =>
  createReducer(asyncReducers)(state, action);
export default rootReducer;
